import CustomList from '../../../../core/components/core/Util/List/CustomList/CustomList';
import CustomListContainer from '../../../../core/components/core/Util/List/CustomList/CustomListContainer';
import config from '../../../config/config';
import Toast from '../../../../core/components/core/Util/Toast/Toast';
import { chooseProfileFilter } from '../../../helpers/chooseProfileFilter';
import { useDispatch } from 'react-redux';
import { useEffect, useMemo, useState } from 'react';
import sleep from 'sleep-promise';
import { loadData } from '../../../../core/components/core/Util/List/CustomList/loadData';

function List() {

    const pathFrontEnd = '/workplansubcategories/';
    const profileFilter = chooseProfileFilter();
    const [filterValues, setFilterValues] = useState({});
    const dispatch = useDispatch();
    const paths = useMemo(() => ({
        pathAdd: pathFrontEnd + 'add',
        pathEdit: pathFrontEnd + 'edit',
        pathView: pathFrontEnd + 'view',
        endpointGetAllEntities: config.endpoints.backend + 'entities/getall',
        endpointGetAllCompanies: config.endpoints.backend + 'companies/getall',
        endpointGetAllProjects: config.endpoints.backend + 'projects/getall',
        endpointGetAllCourtAuditorsCategories: config.endpoints.backend + 'courtauditorscategories/getall',
        endpointDelete: `${config.endpoints.backend}workplansubcategories/delete`,
        endpoint: config.endpoints.backend + 'workplansubcategories/getall'
    }))

    async function updateSession(){
        await sleep(10);
        dispatch({ type: 'UPDATE_SESSION', key: 'custom_list_reload', value: new Date() });
    }

    useEffect(() => {
        async function update(){
            await updateSession();
        }    

        update();
    }, [filterValues]);

    const clearFilters = (target, filterObject) => {
        const filterName = target['name'];
        if(filterName === 'pdc_company_id'){
            delete filterObject.pdc_entity_id;
            delete filterObject.pdc_project_id;
        }else if(filterName === 'pdc_entity_id'){
            delete filterObject.pdc_project_id;
        }
        return filterObject;
    }

    const handleChange = async (element) => {
        const target = element['target'];
        let filters = {...filterValues, [target['name']]: target['value']};
        filters = clearFilters(target,filters);
        setFilterValues(filters)
        
        await updateSession();
    }

    const filters = useMemo(() => ({
        validateOnChange: true,
        showGoBackButton: false,
        showSubmitButton: false,
        update_key: `${filterValues.pdc_company_id}-${filterValues.pdc_entity_id}-${filterValues.pdc_project_id}-${filterValues.pdc_court_auditor_category_id}`,
        handleSubmit: loadData,
        fields: [
            !profileFilter.pdc_company_id && !profileFilter.pdc_entity_id && !profileFilter.pdc_project_ids && {
                name: 'pdc_company_id',
                type: 'select',
                label: 'Empresa',
                options: [],
                handleChange,
                optionsEndpoint: {
                    endpoint: paths.endpointGetAllCompanies,
                    label: 'corporate_name',
                    value: 'id',
                    params: {
                        filter: {
                            ...profileFilter
                        }
                    }
                },
                validations: {
                    required: false
                },
                columnSize: 3,
            },
            !profileFilter.pdc_entity_id && !profileFilter.pdc_entity_id && !profileFilter.pdc_project_ids && {
                name: 'pdc_entity_id',
                type: 'select',
                label: 'Entidade',
                options: [],
                handleChange,
                optionsEndpoint: {
                    endpoint: paths.endpointGetAllEntities,
                    label: 'corporate_name',
                    value: 'id',
                    params: {
                        filter: {
                            ...profileFilter,
                            pdc_company_id: !!filterValues.pdc_company_id ? filterValues.pdc_company_id : profileFilter.pdc_company_id 
                        }
                    }
                },
                validations: {
                    required: false
                },
                columnSize: 3,
            },
            !profileFilter.pdc_project_ids && {
                name: 'pdc_project_id',
                type: 'select',
                label: 'Projeto',
                options: [],
                handleChange,
                optionsEndpoint: {
                    endpoint: paths.endpointGetAllProjects,
                    label: 'project_name',
                    value: 'id',
                    params: {
                        filter: {
                            ...profileFilter,
                            pdc_company_id: !!filterValues.pdc_company_id ? filterValues.pdc_company_id : profileFilter.pdc_company_id, 
                            pdc_entity_id: !!filterValues.pdc_entity_id ? filterValues.pdc_entity_id : profileFilter.pdc_entity_id 
                        }
                    }
                },
                validations: {
                    required: false
                },
                columnSize: 3,
            },
            {
                name: 'pdc_court_auditor_category_id',
                type: 'select',
                label: 'Categoria TCE',
                options: [],
                handleChange,
                optionsEndpoint: {
                    endpoint: paths.endpointGetAllCourtAuditorsCategories,
                    label: 'description',
                    value: 'id'
                },
                validations: {
                    required: false
                },
                columnSize: 3,
            }
        ],
        values: {
            pdc_company_id: filterValues.pdc_company_id,
            pdc_entity_id: filterValues.pdc_entity_id,
            pdc_project_id: filterValues.pdc_project_id,
            pdc_court_auditor_category_id: filterValues.pdc_court_auditor_category_id
        }
    }), [paths, filterValues]);

    const list = useMemo(() => {
        let list = {
            labelTitle: 'Lista de sub categorias do plano de trabalho',
            labelTitleButtonAdd: 'Incluir nova sub categoria do plano de trabalho',
            fieldsShowOnDelete: ['category_name','description'],
            showPrintButtons: true,
            formFilters: filters, 
            filter: {
                ...profileFilter,
                pdc_company_id: !!filterValues.pdc_company_id ? filterValues.pdc_company_id : profileFilter.pdc_company_id,
                pdc_entity_id: !!filterValues.pdc_entity_id ? filterValues.pdc_entity_id : profileFilter.pdc_entity_id,
                pdc_project_id: filterValues.pdc_project_id,
                pdc_court_auditor_category_id: filterValues.pdc_court_auditor_category_id,
            },
            columns: [
                {
                    name: 'project_name',
                    label: 'Projeto'
                },
                {
                    name: 'category_name',
                    label: 'Categoria'
                },
                {
                    name: 'description',
                    label: 'Sub-Categoria'
                },
                {
                    name: 'court_auditor_category_name',
                    label: 'Categoria TCE'
                }
            ],
            values: {
                pdc_company_id: filterValues.pdc_company_id,
                pdc_entity_id: filterValues.pdc_entity_id,
                pdc_project_id: filterValues.pdc_project_id
            }
        };
    
        list = { ...list, ...paths };

        return list;
    });

    const content = useMemo(() => (
        <CustomList list={{ ...list, ...paths }} />
    ), [list, paths, filters]);

    const customListContainer = useMemo(() => (
        <CustomListContainer
            pathAdd={paths.pathAdd}
            labelTitle={list.labelTitle}
            labelTitleButtonAdd={list.labelTitleButtonAdd}
            content={content}
        />
    ), [content, paths, filters, list]);


    return (
        <div>
            {customListContainer}
        </div>
    );
}
export default List;
